import type { DefaultDashboardDefinition } from './dashboard-definition';

export const crmDashboard: DefaultDashboardDefinition = {
  id: "crm.main",
  appId: "crm",
  name: "Crm dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "crm.pipeline-trend.default",
      widgetId: "crm.pipeline-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "crm.win-probability.default",
      widgetId: "crm.win-probability",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "crm.leads.default",
      widgetId: "crm.leads",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "crm.opportunities.default",
      widgetId: "crm.opportunities",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "crm.pipeline-value.default",
      widgetId: "crm.pipeline-value",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "crm.stage-list.default",
      widgetId: "crm.stage-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "crm.pipeline-report.default",
      widgetId: "crm.pipeline-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
